import themeGet from '@styled-system/theme-get';
import styled, { css } from 'styled-components';

export const Heading1Css = css`
  font-family: ${themeGet('typography.mobile.heading1.fontFamily')};
  font-weight: ${themeGet('typography.mobile.heading1.fontWeight')};
  font-size: ${themeGet('typography.mobile.heading1.fontSize')};
  line-height: ${themeGet('typography.mobile.heading1.lineHeight')};
  letter-spacing: ${themeGet('typography.mobile.heading1.letterSpacing')};

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-weight: ${themeGet('typography.desktop.heading1.fontWeight')};
    font-size: ${themeGet('typography.desktop.heading1.fontSize')};
    line-height: ${themeGet('typography.desktop.heading1.lineHeight')};
    letter-spacing: ${themeGet('typography.desktop.heading1.letterSpacing')};
  }
`;

export const Heading1 = styled.h1`
  ${Heading1Css}
`;

export const Heading2Css = css`
  font-family: ${themeGet('typography.mobile.heading1.fontFamily')};
  font-weight: ${themeGet('typography.mobile.heading2.fontWeight')};
  font-size: ${themeGet('typography.mobile.heading2.fontSize')};
  line-height: ${themeGet('typography.mobile.heading2.lineHeight')};
  letter-spacing: ${themeGet('typography.mobile.heading2.letterSpacing')};

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-weight: ${themeGet('typography.desktop.heading2.fontWeight')};
    font-size: ${themeGet('typography.desktop.heading2.fontSize')};
    line-height: ${themeGet('typography.desktop.heading2.lineHeight')};
    letter-spacing: ${themeGet('typography.desktop.heading2.letterSpacing')};
  }
`;

export const Heading2 = styled.h2`
  ${Heading2Css}
`;

export const Heading3Css = css`
  font-family: ${themeGet('typography.mobile.heading1.fontFamily')};
  font-weight: ${themeGet('typography.mobile.heading3.fontWeight')};
  font-size: ${themeGet('typography.mobile.heading3.fontSize')};
  line-height: ${themeGet('typography.mobile.heading3.lineHeight')};
  letter-spacing: ${themeGet('typography.mobile.heading3.letterSpacing')};

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-weight: ${themeGet('typography.desktop.heading3.fontWeight')};
    font-size: ${themeGet('typography.desktop.heading3.fontSize')};
    line-height: ${themeGet('typography.desktop.heading3.lineHeight')};
    letter-spacing: ${themeGet('typography.desktop.heading3.letterSpacing')};
  }
`;

export const Heading3 = styled.h3`
  ${Heading3Css}
`;

export const Heading4Css = css`
  font-family: ${themeGet('typography.mobile.heading1.fontFamily')};
  font-weight: ${themeGet('typography.mobile.heading4.fontWeight')};
  font-size: ${themeGet('typography.mobile.heading4.fontSize')};
  line-height: ${themeGet('typography.mobile.heading4.lineHeight')};
  letter-spacing: ${themeGet('typography.mobile.heading4.letterSpacing')};

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-weight: ${themeGet('typography.desktop.heading4.fontWeight')};
    font-size: ${themeGet('typography.desktop.heading4.fontSize')};
    line-height: ${themeGet('typography.desktop.heading4.lineHeight')};
    letter-spacing: ${themeGet('typography.desktop.heading4.letterSpacing')};
  }
`;

export const Heading4 = styled.h4`
  ${Heading4Css}
`;

export const Heading5Css = css`
  font-family: ${themeGet('typography.mobile.heading1.fontFamily')};
  font-weight: ${themeGet('typography.mobile.heading5.fontWeight')};
  font-size: ${themeGet('typography.mobile.heading5.fontSize')};
  line-height: ${themeGet('typography.mobile.heading5.lineHeight')};
  letter-spacing: ${themeGet('typography.mobile.heading5.letterSpacing')};

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-weight: ${themeGet('typography.desktop.heading5.fontWeight')};
    font-size: ${themeGet('typography.desktop.heading5.fontSize')};
    line-height: ${themeGet('typography.desktop.heading5.lineHeight')};
    letter-spacing: ${themeGet('typography.desktop.heading5.letterSpacing')};
  }
`;

export const Heading5 = styled.h5`
  ${Heading5Css}
`;

export const Body1Css = css`
  font-family: ${themeGet('typography.mobile.heading1.fontFamily')};
  font-weight: ${themeGet('typography.mobile.body1.fontWeight')};
  font-size: ${themeGet('typography.mobile.body1.fontSize')};
  line-height: ${themeGet('typography.mobile.body1.lineHeight')};
  letter-spacing: ${themeGet('typography.mobile.body1.letterSpacing')};

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-weight: ${themeGet('typography.desktop.body1.fontWeight')};
    font-size: ${themeGet('typography.desktop.body1.fontSize')};
    line-height: ${themeGet('typography.desktop.body1.lineHeight')};
    letter-spacing: ${themeGet('typography.desktop.body1.letterSpacing')};
  }
`;

export const Body1 = styled.p`
  ${Body1Css}
`;

export const Body2Css = css`
  font-family: ${themeGet('typography.mobile.heading1.fontFamily')};
  font-weight: ${themeGet('typography.mobile.body2.fontWeight')};
  font-size: ${themeGet('typography.mobile.body2.fontSize')};
  line-height: ${themeGet('typography.mobile.body2.lineHeight')};
  letter-spacing: ${themeGet('typography.mobile.body2.letterSpacing')};

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-weight: ${themeGet('typography.desktop.body2.fontWeight')};
    font-size: ${themeGet('typography.desktop.body2.fontSize')};
    line-height: ${themeGet('typography.desktop.body2.lineHeight')};
    letter-spacing: ${themeGet('typography.desktop.body2.letterSpacing')};
  }
`;

export const Body2 = styled.p`
  ${Body2Css}
`;

export const Body3Css = css`
  font-family: ${themeGet('typography.mobile.heading1.fontFamily')};
  font-weight: ${themeGet('typography.mobile.body3.fontWeight')};
  font-size: ${themeGet('typography.mobile.body3.fontSize')};
  line-height: ${themeGet('typography.mobile.body3.lineHeight')};
  letter-spacing: ${themeGet('typography.mobile.body3.letterSpacing')};

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-weight: ${themeGet('typography.desktop.body3.fontWeight')};
    font-size: ${themeGet('typography.desktop.body3.fontSize')};
    line-height: ${themeGet('typography.desktop.body3.lineHeight')};
    letter-spacing: ${themeGet('typography.desktop.body3.letterSpacing')};
  }
`;

export const Body3 = styled.p`
  ${Body3Css}
`;

export const Body4Css = css`
  font-family: ${themeGet('typography.mobile.heading1.fontFamily')};
  font-weight: ${themeGet('typography.mobile.body4.fontWeight')};
  font-size: ${themeGet('typography.mobile.body4.fontSize')};
  line-height: ${themeGet('typography.mobile.body4.lineHeight')};
  letter-spacing: ${themeGet('typography.mobile.body4.letterSpacing')};

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-weight: ${themeGet('typography.desktop.body4.fontWeight')};
    font-size: ${themeGet('typography.desktop.body4.fontSize')};
    line-height: ${themeGet('typography.desktop.body4.lineHeight')};
    letter-spacing: ${themeGet('typography.desktop.body4.letterSpacing')};
  }
`;

export const Body4 = styled.p`
  ${Body4Css}
`;
